import { render, staticRenderFns } from "./teacher-view.vue?vue&type=template&id=e893bdee&"
import script from "./teacher-view.vue?vue&type=script&lang=js&"
export * from "./teacher-view.vue?vue&type=script&lang=js&"
import style0 from "./teacher-view.vue?vue&type=style&index=0&id=e893bdee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports